import { render } from "./TheContactComponent.vue?vue&type=template&id=e2c0a0b6&scoped=true"
import script from "./TheContactComponent.vue?vue&type=script&lang=js"
export * from "./TheContactComponent.vue?vue&type=script&lang=js"

import "./TheContactComponent.vue?vue&type=style&index=0&id=e2c0a0b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2c0a0b6"]])

export default __exports__